<era-pane>
  <form [formGroup]="form">
    <div class="d-flex">
      <h5 class="mt-auto small-caps">App Lock</h5>
      <div class="ms-auto">
        @if (canDelete() && !editMode && !!setting) {
          <button type="button"
                  class="btn btn-outline-primary border-0"
                  (click)="delete()">
            <fa-icon [icon]="['fas', 'trash-alt']"></fa-icon>
          </button>
        } @else if (allowEdit()) {
          <button type="button"
                  id="toggle-app-lock-edit-mode"
                  class="btn btn-outline-primary border-0"
                  (click)="toggleEditMode()">
            @if (!editMode) {
              <fa-icon [icon]="['fas', 'pencil-alt']"></fa-icon>
            } @else {
              <fa-icon [icon]="['far', 'save']"></fa-icon>
            }
          </button>
        }
      </div>
    </div>

    @if (editMode) {
      <div>
        <select class="form-select"
                formControlName="setting">
          @if (!overrideMode) {
            <option disabled
                    selected>{{ setting }}</option>
          } @else {
            @for (setting of settings(); track setting) {
              <option [ngValue]="setting">
                {{ setting }}
              </option>
            }
          }
        </select>
        @if (!overrideMode) {
          <small class="form-text text-muted d-inline">This selection is inherited</small>
          @if (inheritPossible()) {
            <button id="stop-inherithing-app-lock-button"
                    class="btn btn-link btn-sm float-end"
                    (click)="toggleOverrideMode()">
              Stop inheriting
            </button>
          }
        } @else {
          <small class="form-text text-muted d-inline">This selection is an override</small>
          @if (inheritPossible()) {
            <button id="stop-override-app-lock-button"
                    class="btn btn-link btn-sm float-end"
                    (click)="toggleOverrideMode()">
              Remove override
            </button>
          }
        }
      </div>
    }
  </form>

  <table class="table table-sm table-list">
    <thead>
      <tr>
        <th colspan="2"
            scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <!-- Bundle Identifier -->
      <tr>
        <th title="The Bundle Identifier"
            data-toggle="tooltip"
            data-placement="right"
            scope="row">
          <label class="col-form-label">Bundle ID</label>
        </th>
        <td>
          <label class="col-form-label">{{ setting }}</label>
        </td>
      </tr>
    </tbody>
  </table>
</era-pane>